import { actions } from "@ehi/global-marketing-interface";

const {
    initiateState,
} = actions.reservations;

export const updatePickupAndReturnTimes = (timeDate, exchangeType) => (dispatch) => {
    dispatch(
        initiateState.set('timestamp', {
            timestamp: timeDate,
            exchangeType,
        })
    );
};